export default "__VITE_ASSET__e22022a5__"